import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"

import Modal from "../atoms/Modal"
import Popup from "../atoms/Popup"
import Box from "../atoms/Box"

import ThemeSwitcher from "../utils/ThemeSwitcher"

import ImageText from "../molecules/ImageText/ImageTextPopup/ImageTextMoleculePopup"
import SectionTitle from "../molecules/SectionTitle"

const normalizeTheme = (themeType, site) => {
  // TODO: move elsewhere and import in
  if (themeType === "default") return site.theme.backgroundTheme
  return themeType
}

const ImageTextPopup = ({
  popupId,
  site,
  bg,
  theme,
  popup,
  modal,
  ...rest
}) => {
  return (
    <Popup
      {...rest}
      popup={popup}
      modal={modal}
      bg={popup?.bg}
      theme={normalizeTheme(popup?.theme, site)}
      overlayOpacity={popup?.overlayOpacity}
    >
      <ThemeSwitcher theme={theme}>
        <Box backgroundColor={`background.${bg}`}>
          <ImageText modal={modal} {...rest} />
        </Box>
      </ThemeSwitcher>
    </Popup>
  )
}

ImageTextPopup.propTypes = {
  strapi_id: PropTypes.number.isRequired,
  popup: PropTypes.shape(Popup.strapiProps).isRequired,
  modal: PropTypes.shape(Modal.strapiProps).isRequired,
  sectionTitle: PropTypes.shape(SectionTitle.strapiProps),
  integration: PropTypes.shape({
    type: PropTypes.oneOf(["customHtml"]),
    data: PropTypes.object,
  }),
}

export default ImageTextPopup

export const query = graphql`
  fragment ImageTextPopup on STRAPI__COMPONENT_POPUPS_IMAGE_TEXT_POPUP {
    strapi_id
    popup {
      ...Popup
    }
    modal {
      ...Modal
    }
    theme
    bg
    sectionTitle {
      ...SectionTitle
    }
    button {
      ...Button
    }
    button2 {
      ...Button
    }
    imageOrVideo {
      ...ImageOrVideo
    }
    text {
      ...SectionTitle
    }
    card {
      ...Card
    }
    verticalText {
      ...VerticalText
    }
    socialLinks {
      ...SocialLink
    }
    socialLinkStyles {
      ...SocialLinkStyles
    }
    alignProp
    location
    mediaLocation
    mediaRatio
    useNewsletter
    xOffsetOverlap
    yOffsetOverlap
    mediaPositioning
    mediaPositioningOnMobile
  }
`
